import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app-routers';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TokenInterceptor } from './app/core/Interceptors/token.interceptor';
import { NetworkConnectionInterceptor } from './app/core/Interceptors/network-connection.interceptor';
import { ErrorInterceptor } from './app/core/Interceptors/error.interceptor';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpPaths } from './app/core/constants/http-paths';
import { BasicConstants } from './app/core/constants/basics-constant';
import { ChangeUserData } from './app/core/Store/Auth/AuthAction';
import { provideStore, Store } from '@ngrx/store';
import { AuthReducer } from './app/core/Store/Auth/AuthReducer';
import { environment as env } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ServiceCategoryReducer } from './app/core/Store/ServiceCategoryTree/ServiceCategoryReducer';
import { CategoryTreeReducer } from './app/core/Store/CategoryTree/CategoryTreeReducer';
import { InternalDivisionReducer } from './app/core/Store/InternalDivision/InternalDivisionReducer';
import { MenuReducer } from './app/core/Store/Menu/MenuReducer';
import { ProjectLocationReducer } from './app/core/Store/ProjectLocation/ProjectLocationReducer';
import { TeamsLocationReducer } from './app/core/Store/TeamsLocation/TeamsLocationReducer';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}


export function initializeUserData(http: HttpClient, Store: Store) {
  return (): Observable<any> => http.get<any>(`${localStorage.getItem('companyLink')}${HttpPaths.API_GET_USER_DATA}`).pipe(map((res) => {
    if (res) {
      Store.dispatch(ChangeUserData(res.data))
      localStorage.setItem(BasicConstants.USER_DATA, JSON.stringify(res.data));
      localStorage.setItem(BasicConstants.USER_ID, res.data.userId);
    }
  }),
    catchError(() => {
      return of(null);
    }));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideStore({ 
      ShardStore: AuthReducer, 
      ServiceCategoryTreeStore: ServiceCategoryReducer, 
      CategoryTreeStore: CategoryTreeReducer,
      InternalDivisionStore: InternalDivisionReducer,
      ProjectLocationStore: ProjectLocationReducer,
      TeamsLocationStore: TeamsLocationReducer,
      MenuStore: MenuReducer
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([TokenInterceptor, NetworkConnectionInterceptor, ErrorInterceptor]),
    ),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUserData,
      multi: true,
      deps: [HttpClient, Store],
    },
    {
      provide: DateAdapter,
      useFactory: adapterFactory,
    },
    // Initialize AngularFire (compat) and Messaging at application bootstrap
    importProvidersFrom(
      AngularFireModule.initializeApp(env.firebase),
      AngularFireMessagingModule
    ),
  ],
};
